import type { Locale } from "../types/content";
import { locales } from "../content/config";

export const defaultLocale: Locale = "en";

export const routePaths = [
  "",
  "moldova",
  "israel",
  "programs",
  "programs/energy-resilience",
  "programs/climate-smart-agriculture",
  "programs/green-wine-moldova",
  "programs/energy-communities",
  "insights",
  "about",
  "transparency",
  "contact",
  "privacy",
  "terms"
];

export function isLocale(value: string | undefined): value is Locale {
  return Boolean(value && locales.includes(value as Locale));
}

export function localizedPath(locale: Locale, path = "") {
  const clean = path.replace(/^\/+/, "");
  return `/${locale}${clean ? `/${clean}` : ""}`;
}

export function pathWithoutLocale(pathname: string) {
  const [, maybeLocale, ...rest] = pathname.split("/");
  return isLocale(maybeLocale) ? `/${rest.join("/")}`.replace(/\/$/, "") || "/" : pathname;
}
